import { render, staticRenderFns } from "./Avatars.vue?vue&type=template&id=512cf620&"
import script from "./Avatars.vue?vue&type=script&lang=js&"
export * from "./Avatars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports